import React from "react";
import {useDispatch} from "react-redux";
import {setSelectedRecord} from "../../../reducers/applicationBuilder.slice";
import {Tooltip} from "@material-ui/core";
import StyledTreeItem from "./TreeItem";
import TreeItemSchemaProperty from "./TreeItemSchemaProperty";

const RenderTree = ({items = [], parentPath, type, openContext, isProperty}) => {
    const dispatch = useDispatch();

    return (
        items.map((item, index) => {
            const path = parentPath ? parentPath + `.children.${index}` : `children.${index}`;

            if (item.children) {
                return <StyledTreeItem
                    label={item.name}
                    nodeId={path}
                    onContextMenu={(e) => {
                        e.stopPropagation();
                        openContext(e, item.id)
                    }}
                    searchKey={item.id}
                    isRoot={true}
                >
                    {RenderTree({items: item.children, parentPath: path, type: item.id, openContext})}
                </StyledTreeItem>
            }
            if (item.properties) {
                return <TreeItemSchemaProperty
                    onContextMenu={(e) => {
                        openContext(e, type, item.id)
                    }}
                    label={
                        <Tooltip title={item.name}>
                            <div style={{
                                width: '100px',
                                overflow: 'hidden',
                                textOverflow: "ellipsis"
                            }}>
                                {item.name || item.id}
                            </div>
                        </Tooltip>
                    }
                    nodeId={path}
                    isRoot={true}
                    onDoubleClick={(e) => {
                        e.stopPropagation();
                        dispatch(setSelectedRecord({type: type, id: item.collection && item.id}))
                    }}
                    source={item.source}
                >
                    {RenderTree({
                        items: item.properties,
                        parentPath: path,
                        type: item.id,
                        openContext,
                        isProperty: true
                    })}
                </TreeItemSchemaProperty>
            }
            if (isProperty) {
                return <TreeItemSchemaProperty
                    label={
                        <Tooltip title={item.name}>
                            <div style={{
                                width: '100px',
                                overflow: 'hidden',
                                textOverflow: "ellipsis"
                            }}>
                                {item.name || item.id}
                            </div>
                        </Tooltip>
                    }
                    item={{...item, path}}
                    nodeId={path}
                    source={item.source}
                />
            }
            return <StyledTreeItem
                label={item.name || item.id}
                nodeId={path}
                onDoubleClick={() => {
                    dispatch(setSelectedRecord({type: type, id: item.id}))
                }}
            />
        })
    )
}
export default RenderTree